import React from "react";

/**
 * DS FieldLabel — figma 257:1499 "title" component.
 *
 * Pretendard SemiBold 14/22 Text/Primary, padding y=10
 * required=true 면 우측에 빨간 asterisk (4×22 width 영역) — 색상 System/Error
 * Width: 183px (figma form 표준 라벨 너비)
 *
 * @param {object} props
 * @param {string} props.children
 * @param {boolean} [props.required]
 * @param {string|number} [props.width=183]
 */
const DSFieldLabel = ({ children, required = false, width = 183, className = "" }) => {
  return (
    <div className={`ds-field-label ${className}`} style={{ width }}>
      <span className="ds-field-label__text">{children}</span>
      {required && <span className="ds-field-label__required" aria-hidden>*</span>}
    </div>
  );
};

export default React.memo(DSFieldLabel);
